module.exports = __webpack_public_path__ + "img/ws.4c7ffc54.svg";